import { useCallback } from 'react';
import { JUICYHOUSE_CALL_EVENT } from '../../../../../shared/utils/matrix/matrixRoomUtils';

/**
 * Send call-scoped tip payload into the active Matrix room as a custom event.
 * This keeps in-call tips out of chat timelines.
 */
export function useSendTextMessageFromCall({ client, isInitialized, roomId }) {
  return useCallback(
    async (text) => {
      const trimmed = typeof text === 'string' ? text.trim() : '';
      if (!client || !isInitialized || !roomId || !trimmed) {
        return { success: false, error: 'Call room is not ready' };
      }
      try {
        const result = await client.sendEvent?.(roomId, JUICYHOUSE_CALL_EVENT, {
          type: 'call_tip',
          body: trimmed,
        });
        return { success: true, eventId: result?.event_id || result?.eventId || null };
      } catch (error) {
        return { success: false, error: error?.message || 'Failed to send call tip event' };
      }
    },
    [client, isInitialized, roomId]
  );
}
